// src/components/layout/MobileMenuButton.jsx - erx mobile

import { Menu } from 'lucide-react';
import { cn } from '@/lib/utils';

export function MobileMenuButton({ onClick, className }) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'lg:hidden rounded-md p-2 text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary',
        className
      )}
    >
      <span className="sr-only">Open menu</span>
      <Menu className="h-6 w-6" />
    </button>
  );
}